import { watch } from 'vue'
import { useQuery, useMutation } from '@tanstack/vue-query'
import { $axios, $queryClient } from '@/boot/initApi'

const QUERY_KEY = ['sessions']

export default ({ sessions }) => ({
  indexSessions: ({ enabled = true } = {}) => {
    const query = useQuery({
      queryKey: QUERY_KEY,
      queryFn: async () => {
        const { data } = await $axios.get('/api/sessions')
        return data ?? []
      },
      enabled,
      staleTime: 1000 * 60
    }, $queryClient)

    watch(query.data, val => {
      if (val) sessions.value = val
    }, { immediate: true })

    return query
  },

  destroySession: () => useMutation({
    mutationFn: id => $axios.delete(`/api/sessions/${id}`),
    onSuccess: () => $queryClient.invalidateQueries({ queryKey: QUERY_KEY })
  }, $queryClient),

  destroyOtherSessions: () => useMutation({
    mutationFn: () => Promise.all(
      sessions.value.filter(session => !session.current).map(session => $axios.delete(`/api/sessions/${session.id}`))
    ),
    onSuccess: () => $queryClient.invalidateQueries({ queryKey: QUERY_KEY })
  }, $queryClient)
})
